

function checkNested(obj, args) {
    for (let i = 0; i < args.length; i++) {
        if (!obj || !obj.hasOwnProperty(args[i])) {
            return false;
        }
        obj = obj[args[i]];
    }
    return true;
}

function retryCheck(obj, args, callback, failCallback, tries){
    
    if(checkNested(obj,args)){
        callback();
        return;
    }

    //we have to wait, setup an interval timer
    //and run it a max tries times
    const timer = setInterval(()=>{

        tries--;

        if(checkNested(obj, args)){
            clearInterval(timer);
            callback();
        }

        if(tries<=0){
            clearInterval(timer);
            if(typeof(failCallback)=='function') {
                failCallback();
            }
        }

    }, 250);
    
   
}

function waitForGlobal(keyPath, callback, failCallback, maxTries) {
    const args = keyPath.split('.');
    const obj = window;
    if (checkNested(obj, args)) {
        callback();
    } else {
        retryCheck(obj ,args,callback,failCallback, maxTries??20);
    }
}



export {
    waitForGlobal
}